import { Url } from "./url";
import { environment } from "../../../../../environments/environment";

export class PbmBenefitBackendUrl extends Url {
  constructor(private action: string) {
    super(action);
  }

  public getUrl(): string {
    return environment.pbmBenefitBackendUrl + this.action;
  }
}
